 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"BackToTop":"BackToTop","BarChart~LineChart~MixedChat~complex-table~export-excel~guide~merge-header~select-excel~upload-excel~zip":"BarChart~LineChart~MixedChat~complex-table~export-excel~guide~merge-header~select-excel~upload-excel~zip","BarChart~LineChart~MixedChat~guide":"BarChart~LineChart~MixedChat~guide","BarChart":"BarChart","LineChart":"LineChart","MixedChat":"MixedChat","complex-table~export-excel~guide~merge-header~select-excel":"complex-table~export-excel~guide~merge-header~select-excel","example-create~example-edit~guide~tinymce":"example-create~example-edit~guide~tinymce","guide":"guide","complex-table~export-excel~merge-header~select-excel~upload-excel":"complex-table~export-excel~merge-header~select-excel~upload-excel","complex-table~permission-role":"complex-table~permission-role","complex-table":"complex-table","export-excel":"export-excel","merge-header":"merge-header","select-excel":"select-excel","upload-excel":"upload-excel","zip":"zip","CountTo~draggable-kanban":"CountTo~draggable-kanban","draggable-kanban":"draggable-kanban","CountTo~draggable-table":"CountTo~draggable-table","CountTo":"CountTo","draggable-table":"draggable-table","clipboard":"clipboard","permission-role":"permission-role","componentMixin":"componentMixin","draggable-dialog":"draggable-dialog","dynamic-table":"dynamic-table","error-page-401":"error-page-401","error-page-404":"error-page-404","example-create~example-edit~tinymce":"example-create~example-edit~tinymce","example-create~example-edit":"example-create~example-edit","example-create":"example-create","example-edit":"example-edit","tinymce":"tinymce","example-list":"example-list","inline-edit-table":"inline-edit-table","menu1":"menu1","menu1-1":"menu1-1","menu1-2":"menu1-2","menu1-2-1":"menu1-2-1","menu1-2-2":"menu1-2-2","menu1-3":"menu1-3","menu2":"menu2","pdf":"pdf","permission-directive":"permission-directive","permission-page":"permission-page","profile":"profile","redirect":"redirect","sticky":"sticky","tab":"tab","theme":"theme","userManager":"userManager"}[chunkId]||chunkId) + "." + {"BackToTop":"79a93264","BarChart~LineChart~MixedChat~complex-table~export-excel~guide~merge-header~select-excel~upload-excel~zip":"08841841","BarChart~LineChart~MixedChat~guide":"a45e8b82","BarChart":"e8331355","LineChart":"d01689d0","MixedChat":"bec97827","complex-table~export-excel~guide~merge-header~select-excel":"1b83ec06","example-create~example-edit~guide~tinymce":"14e5eb3b","guide":"07bbe514","complex-table~export-excel~merge-header~select-excel~upload-excel":"1c2ebefa","complex-table~permission-role":"6ba8b218","complex-table":"5afec3aa","export-excel":"edb0cb6b","merge-header":"b83d1984","select-excel":"3049e37e","upload-excel":"97411f38","zip":"98c660f6","CountTo~draggable-kanban":"a4d00d25","draggable-kanban":"e07a13eb","CountTo~draggable-table":"1d56c3c1","CountTo":"a8feb185","draggable-table":"130b03de","clipboard":"758751b4","permission-role":"27eec392","componentMixin":"06541a3e","draggable-dialog":"87c654d9","dynamic-table":"effaae03","error-page-401":"aa68d3aa","error-page-404":"f87c2acd","example-create~example-edit~tinymce":"20c7a727","example-create~example-edit":"285e7968","example-create":"ca65504e","example-edit":"79978bbb","tinymce":"5237ca7d","example-list":"f6efabdf","inline-edit-table":"7aa9dc3f","menu1":"d8ff0f18","menu1-1":"acc86288","menu1-2":"7a5e3d91","menu1-2-1":"d2a1edc7","menu1-2-2":"0654bcab","menu1-3":"1aeaf0f4","menu2":"24251b07","pdf":"391e6355","permission-directive":"4a3bdfb9","permission-page":"12c02451","profile":"b5ff8c05","redirect":"8443e6d8","sticky":"d366348c","tab":"594f7a6a","theme":"bd416ea7","userManager":"ae54a337"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"BackToTop":1,"BarChart":1,"LineChart":1,"MixedChat":1,"guide":1,"export-excel":1,"upload-excel":1,"draggable-kanban":1,"CountTo":1,"draggable-table":1,"permission-role":1,"componentMixin":1,"draggable-dialog":1,"error-page-401":1,"error-page-404":1,"example-create~example-edit~tinymce":1,"example-create~example-edit":1,"tinymce":1,"example-list":1,"inline-edit-table":1,"pdf":1,"permission-directive":1,"profile":1,"sticky":1,"tab":1,"theme":1,"userManager":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"BackToTop":"BackToTop","BarChart~LineChart~MixedChat~complex-table~export-excel~guide~merge-header~select-excel~upload-excel~zip":"BarChart~LineChart~MixedChat~complex-table~export-excel~guide~merge-header~select-excel~upload-excel~zip","BarChart~LineChart~MixedChat~guide":"BarChart~LineChart~MixedChat~guide","BarChart":"BarChart","LineChart":"LineChart","MixedChat":"MixedChat","complex-table~export-excel~guide~merge-header~select-excel":"complex-table~export-excel~guide~merge-header~select-excel","example-create~example-edit~guide~tinymce":"example-create~example-edit~guide~tinymce","guide":"guide","complex-table~export-excel~merge-header~select-excel~upload-excel":"complex-table~export-excel~merge-header~select-excel~upload-excel","complex-table~permission-role":"complex-table~permission-role","complex-table":"complex-table","export-excel":"export-excel","merge-header":"merge-header","select-excel":"select-excel","upload-excel":"upload-excel","zip":"zip","CountTo~draggable-kanban":"CountTo~draggable-kanban","draggable-kanban":"draggable-kanban","CountTo~draggable-table":"CountTo~draggable-table","CountTo":"CountTo","draggable-table":"draggable-table","clipboard":"clipboard","permission-role":"permission-role","componentMixin":"componentMixin","draggable-dialog":"draggable-dialog","dynamic-table":"dynamic-table","error-page-401":"error-page-401","error-page-404":"error-page-404","example-create~example-edit~tinymce":"example-create~example-edit~tinymce","example-create~example-edit":"example-create~example-edit","example-create":"example-create","example-edit":"example-edit","tinymce":"tinymce","example-list":"example-list","inline-edit-table":"inline-edit-table","menu1":"menu1","menu1-1":"menu1-1","menu1-2":"menu1-2","menu1-2-1":"menu1-2-1","menu1-2-2":"menu1-2-2","menu1-3":"menu1-3","menu2":"menu2","pdf":"pdf","permission-directive":"permission-directive","permission-page":"permission-page","profile":"profile","redirect":"redirect","sticky":"sticky","tab":"tab","theme":"theme","userManager":"userManager"}[chunkId]||chunkId) + "." + {"BackToTop":"afa9cd01","BarChart~LineChart~MixedChat~complex-table~export-excel~guide~merge-header~select-excel~upload-excel~zip":"31d6cfe0","BarChart~LineChart~MixedChat~guide":"31d6cfe0","BarChart":"97ca10c8","LineChart":"e15bce16","MixedChat":"16533d4e","complex-table~export-excel~guide~merge-header~select-excel":"31d6cfe0","example-create~example-edit~guide~tinymce":"31d6cfe0","guide":"d7ba16a8","complex-table~export-excel~merge-header~select-excel~upload-excel":"31d6cfe0","complex-table~permission-role":"31d6cfe0","complex-table":"31d6cfe0","export-excel":"48569099","merge-header":"31d6cfe0","select-excel":"31d6cfe0","upload-excel":"a4a2e625","zip":"31d6cfe0","CountTo~draggable-kanban":"31d6cfe0","draggable-kanban":"b8a48c04","CountTo~draggable-table":"31d6cfe0","CountTo":"e69006e6","draggable-table":"5146d0c1","clipboard":"31d6cfe0","permission-role":"9d22acd1","componentMixin":"1b7bc0dd","draggable-dialog":"13fb783a","dynamic-table":"31d6cfe0","error-page-401":"055a58f4","error-page-404":"bf577cba","example-create~example-edit~tinymce":"acbde9a6","example-create~example-edit":"7eb89347","example-create":"31d6cfe0","example-edit":"31d6cfe0","tinymce":"34bb86e3","example-list":"8d9ca7cb","inline-edit-table":"7884b6ea","menu1":"31d6cfe0","menu1-1":"31d6cfe0","menu1-2":"31d6cfe0","menu1-2-1":"31d6cfe0","menu1-2-2":"31d6cfe0","menu1-3":"31d6cfe0","menu2":"31d6cfe0","pdf":"678f4df9","permission-directive":"e1c363ff","permission-page":"31d6cfe0","profile":"defcb9b2","redirect":"31d6cfe0","sticky":"56fab1d7","tab":"8fd8ab8b","theme":"ea314cb7","userManager":"c8d57d37"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonpvueApp"] = window["webpackJsonpvueApp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
